import { render, staticRenderFns } from "./resultPop.vue?vue&type=template&id=b1c85f22&scoped=true"
import script from "./resultPop.vue?vue&type=script&lang=js"
export * from "./resultPop.vue?vue&type=script&lang=js"
import style0 from "./resultPop.vue?vue&type=style&index=0&id=b1c85f22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1c85f22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1c85f22')) {
      api.createRecord('b1c85f22', component.options)
    } else {
      api.reload('b1c85f22', component.options)
    }
    module.hot.accept("./resultPop.vue?vue&type=template&id=b1c85f22&scoped=true", function () {
      api.rerender('b1c85f22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/goodsListActive/components/resultPop.vue"
export default component.exports